import { Button } from '@toggle/design-system';
import { Entity, formatTicker } from '@toggle/toggle';
import clsx from 'clsx';
import React from 'react';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { WatchlistTrigger } from '~/components/watchlist/watchlist-trigger/WatchlistTrigger';

import styles from './EntityHeaderWatchlist.module.scss';

export interface EntityHeaderWatchlistProps {
  entity: Entity;
  logoSize?: number;
  className?: string;
}

export const EntityHeaderWatchlist = ({
  entity,
  logoSize = 40,
  className,
}: EntityHeaderWatchlistProps) => {
  const ticker = formatTicker(entity);
  const entityName = entity.name_short || entity.name_full;

  return (
    <div className={clsx(styles.contentWrapper, className)}>
      <div>
        <div className={styles.ticker}>
          <div className={styles.leftImageContainer}>
            <AssetLogoContainer size={logoSize} entity={entity} />
          </div>
          <div className={styles.titleContainer}>
            <span data-testid={`label${entityName}`}>{entityName}</span>
            <span className={styles.tag}>{ticker}</span>
          </div>
        </div>
      </div>
      <div className={styles.watchlistWrapper}>
        <WatchlistTrigger
          tag={entity.tag}
          dropdownProps={{
            strategy: 'fixed',
            placement: 'top-start',
            inPortal: false,
          }}
          renderTrigger={isInWatchlist => (
            <Button
              className={clsx(styles.watchlistButton, {
                [styles.watchlistButtonActive]: isInWatchlist,
              })}
              data-testid="watchlist-button"
              size="xsmall"
              variant="tertiary"
              iconName={isInWatchlist ? 'Checkmark' : 'Add'}
            />
          )}
        />
      </div>
    </div>
  );
};
